const expander = (props) => {
  const { summary, details } = props;
  return `
  <details class="nhsuk-details nhsuk-expander">
  <summary class="nhsuk-details__summary">
    <span class="nhsuk-details__summary-text">
      ${summary}
    </span>
  </summary>
  <div class="nhsuk-details__text">
    ${details}
  </div>
</details>`;
};

const unitTable = () => {
  return `
  <p data-block-key="ldt77">A 750ml bottle of red, white or rosé wine (ABV 13.5%) contains 10 units.</p>
  <p data-block-key="mq82j">See the guide below to find out how many units are in your favourite tipple.</p>
  <div class="nhsuk-table-container">
    <table><caption class="nhsuk-u-visually-hidden">Units and calories for drinks</caption>
      <thead>
        <tr>
          <th scope="col">Type of drink</th>
          <th scope="col">Number of alcohol units</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Single small shot of spirits* (25ml, ABV 40%)</td>
          <td>1 unit</td>
        </tr>
        <tr>
          <td>Alcopop  (275ml, ABV 5.5%)</td>
          <td>1.5 units</td>
        </tr>
        <tr>
          <td>Small glass of red/white/rosé wine  (125ml, ABV 12%)</td>
          <td>1.5 units</td>
        </tr>
        <tr>
          <td>Bottle of lager/beer/cider  (330ml, ABV 5%)</td>
          <td>1.7 units</td>
        </tr>
        <tr>
          <td>Can of lager/beer/cider  (440ml, ABV 5.5%)</td>
          <td>2.4 units</td>
        </tr>
        <tr>
          <td>Pint of lower-strength lager/beer/cider  (ABV 3.6%)</td>
          <td>2 units</td>
        </tr>
        <tr>
          <td>Standard glass of red/white/rosé wine  (175ml, ABV 12%)</td>
          <td>2.1 units</td>
        </tr>
        <tr>
          <td>Pint of higher-strength lager/beer/cider  (ABV 5.2%)</td>
          <td>3 units</td>
        </tr>
        <tr>
          <td>Large glass of red/white/rosé wine  (250ml, ABV 12%)</td>
          <td>3 units</td>
        </tr>
      </tbody>
    </table>
  </div>`;
};

const unitGuide = (el) => {
  el.innerHTML = expander({
    summary: "A guide to drinks and units",
    details: unitTable(),
  });
};

export default unitGuide;
